import React from 'react';
import styled from 'styled-components';
import { AU_STATE_OPTIONS } from '../constants';

type StateOption = {
  code: string;
  label: string;
};

type StateFilterProps = {
  selectedState: string;
  onChange: (stateCode: string) => void;
  options?: readonly StateOption[];
};

const FilterBar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.25rem 0.45rem;
  background: var(--surface);
  border-radius: 8px;
  border: 1px solid var(--border);
  box-shadow: 0 2px 8px var(--shadow);
  margin-bottom: 0.35rem;
  flex-wrap: wrap;
  flex-shrink: 0;

  label {
    font-weight: 600;
    color: var(--text-secondary);
    font-size: 0.85rem;
    white-space: nowrap;
  }

  select {
    min-width: 190px;
    padding: 0.34rem 0.55rem;
    border-radius: 7px;
    border: 1px solid var(--border);
    background: var(--surface);
    color: var(--text);
    font-weight: 500;
    font-size: 0.88rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus {
      outline: none;
      border-color: var(--primary);
      box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary) 18%, transparent);
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;

    select {
      width: 100%;
      min-height: 44px;
    }
  }
`;

const StateFilter: React.FC<StateFilterProps> = ({
  selectedState,
  onChange,
  options = AU_STATE_OPTIONS
}) => {
  return (
    <FilterBar>
      <label htmlFor="state-filter">State</label>
      <select
        id="state-filter"
        value={selectedState}
        onChange={(event) => onChange(event.target.value)}
      >
        {options.map((option) => (
          <option key={option.code} value={option.code}>
            {option.label}
          </option>
        ))}
      </select>
    </FilterBar>
  );
};

export default StateFilter;
